import { useNode } from '@craftjs/core';
import { Box, useTheme } from '@mui/material';
import { ReactNode } from 'react';

import { COLORS } from '@/styles/tokens/colors';

import { useIsBlockEditorEditMode } from '../BlockEditor.context';

/**
 * Wrapper component that adds hover/interaction styles to editable Craft.js components
 * Use this to wrap any component that should have the standard editable appearance
 */
export function EditableComponentWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const theme = useTheme();
  const isEditMode = useIsBlockEditorEditMode();
  const { selected } = useNode((node) => ({
    selected: node.events.selected,
    hovered: node.events.hovered,
  }));

  if (!isEditMode) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        borderRadius: '4px',
        transition: `outline ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
        outline: selected ? `2px solid ${COLORS.BLUE[500]}` : 'none',
        '&:hover': {
          cursor: 'move',
          outline: selected
            ? `2px solid ${COLORS.BLUE[500]}`
            : `1px solid ${COLORS.BLUE[500]}`,
        },
      }}
    >
      {children}
    </Box>
  );
}
